import stylis from 'stylis';
import { currySC } from './utils';
var classes = {};
var bodyGlobals = [];
var i = 0;
var localContext = null;
/**
 * Associa una funzione per generare una classe css ad una chiave autogenerata, restituita poi dal metodo
 *
 * @param classCreator: classFactory
 * @param descendant: boolean
 * @return key: string
 */
export function registerClass(classCreator, descendant) {
    if (descendant === void 0) { descendant = true; }
    var key = 'c' + i++;
    classes[key] = { factory: classCreator, descendant: descendant };
    return key;
}
/**
 * Inserisce dei tratti CSS nell'array che poi verra' associato al body
 *
 * @param globalDef: globalInjector
 * @return void
 */
export var registerGlobal = function (globalDef) {
    bodyGlobals.push(globalDef);
};
/**
 * Utility interna per unire le diverse definizioni di tratti CSS globali
 *
 * @param c: globalInjector[]
 * @param theme: any
 * @return void
 */
var joinGlobals = function (c, theme) {
    return c.map(function (g) { return g(theme); }).join('\n');
};
/**
 * Utility interna per unire le diverse definizioni di tratti CSS locali
 *
 * @param c: ClassContainer
 * @param theme: any
 * @return void
 */
var joinClasses = function (c, theme) {
    return Object.entries(c)
        .filter(function (_a) {
        var _ = _a[0], factory = _a[1].factory;
        if (typeof factory !== 'function') {
            console.log(factory);
        }
        // devo filtrare le factory che non sono function.. strano, dovrebbe essere impossibile se si segue la tipizzazione
        return typeof factory === 'function';
    })
        .map(function (_a) {
        var className = _a[0], _b = _a[1], factory = _b.factory, descendant = _b.descendant;
        return (!descendant ? '&' : '') + "." + className + " { " + factory(theme, currySC(className)) + " }";
    })
        .join('\n');
};
/**
 * Getter per il contesto grafico di una applicazione
 *
 * @return CSSManagerContext | null
 */
export var getContext = function () { return localContext; };
/**
 * Setter per il contesto grafico di una applicazione
 *
 * @param context: CSSManagerContext
 * @return void
 */
export var setContext = function (context) {
    localContext = context;
};
/**
 * Dato un tema e un prefisso, parsa le definizioni locali e globali registrare nell'applicazione e ne genera un CSS
 *
 * @param theme: any
 * @param prefix?: string
 * @return string
 */
export var generateCSS = function (theme, prefix) {
    // il CSS relativo all'applicazione, compresi i portal
    var css = joinClasses(classes, theme);
    if (prefix) {
        css = prefix + ' { ' + css + ' } ';
    }
    // il CSS attaccato direttamente al body, dovrebbe contenere solo poche eccezioni
    var bodyCss = (prefix || 'html') + ' { ' + joinGlobals(bodyGlobals, theme) + '}';
    var allCss = css + '\n\n' + bodyCss;
    return stylis('', allCss);
};
/**
 * Utility interna per generare l'id da assegnare al tag `style`
 *
 * @param context: CSSManagerContext | null
 * @returns string
 */
var generateStyleId = function (context) {
    if (context) {
        var styleTagId = context.styleTagId, portalClasses = context.portalClasses;
        if (styleTagId) {
            return styleTagId;
        }
        else if (Array.isArray(portalClasses) && portalClasses.length > 0) {
            return portalClasses.join('-');
        }
    }
    return 'css-export';
};
/**
 * Aggiorna il css generato precedentemente da injectCSS con le classi registrate nel mentre, probabilmente da
 * componenti caricati in modo lazy
 */
export var refreshCSS = function () {
    if (localContext === null) {
        return;
    }
    var theme = localContext.theme, prefix = localContext.prefix;
    var id = generateStyleId(localContext);
    var style = document.querySelector('#' + id);
    if (style === null) {
        return;
    }
    style.innerHTML = generateCSS(theme, prefix);
};
/**
 * Genera e inietta il css composto dalle classi registrate fino all'esecuzione
 *
 * @param context: CSSManagerContext
 */
export var injectCSS = function (context) {
    var theme = context.theme, prefix = context.prefix;
    localContext = context;
    var id = generateStyleId(context);
    // se esiste gia' un nodo con questo id sono renderizzato server-side oppure c'e' un errore. Nel dubbio, mi fermo
    if (document.querySelector('#' + id)) {
        return;
    }
    var style = document.createElement('style');
    style.id = id;
    style.appendChild(document.createTextNode(generateCSS(theme, prefix)));
    document.head.appendChild(style);
};
//# sourceMappingURL=manager.js.map